import { render, staticRenderFns } from "./FeaturedIn.vue?vue&type=template&id=1a459c78&scoped=true"
import script from "./FeaturedIn.vue?vue&type=script&lang=js"
export * from "./FeaturedIn.vue?vue&type=script&lang=js"
import style0 from "./FeaturedIn.vue?vue&type=style&index=0&id=1a459c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a459c78",
  null
  
)

export default component.exports